import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-basis/basisarchive/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}
 
export const getArchivesDetail = (id) => {
    return request({
        url: '/api/blade-basis/basisarchive/detailById/'+id,
        method: 'get',
    })
}





export const getArchivesDetailByOrderId = (orderId) => {
    return request({
        url: '/api/blade-basis/casearchived/detailByOrderId/'+orderId,
        method: 'get',
    })
}

export const getArchivesDetailByCardId = (cardId) => {
    return request({
        url: '/api/blade-basis/basisarchive/detail/'+cardId,
        method: 'get'
    })
}

export const getListSuper = (current, size, params) => {
    return request({
        url: '/api/blade-basis/casearchived/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getSuperDetail = (id) => {
    return request({
        url: '/api/blade-basis/casearchived/detail/'+id,
        method: 'get',
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/blade-basis/basisarchive/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}
export const removeCasearchived = (ids) => {
    return request({
        url: '/api/blade-basis/casearchived/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-basis/basisarchive/submit',
        method: 'post',
        data: row
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-basis/basisarchive/submit',
        method: 'post',
        data: row
    })
}
